<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="profilEmprunteur">
                <ng-container>
                  <div class="formControl mt">
                    <div class="row d-flex align-items-center">
                      <div class="col col-md-6">
                        <question-description
                          titleDir="left"
                          subTitleDir="left"
                          title="Est-ce que vous effectuez un travail en station debout ?"
                          [titleStyle]="{ fontSize: '16px' }"
                        >
                        </question-description>
                      </div>
                      <div class="col col-md-6 clear-m">
                        <pr-input-radio
                          formControlName="travailDebout"
                          direction="column"
                          [isDefault]="false"
                          [toggle]="true"
                        >
                        </pr-input-radio>
                      </div>
                    </div>
                  </div>
                  <div class="formControl mt">
                    <div class="row d-flex align-items-center">
                      <div class="col col-md-6">
                        <question-description
                          titleDir="left"
                          subTitleDir="left"
                          title="Est-ce que vous exercez un travail avec des produits dangereux ?"
                          [titleStyle]="{ fontSize: '16px' }"
                        >
                        </question-description>
                      </div>
                      <div class="col col-md-6 clear-m">
                        <pr-input-radio
                          formControlName="travailProduitsDangereux"
                          direction="column"
                          [isDefault]="false"
                          [toggle]="true"
                        >
                        </pr-input-radio>
                      </div>
                    </div>
                  </div>
                  <div class="formControl mt">
                    <pr-input-radio
                      formControlName="travailARisque"
                      direction="column"
                      [isDefault]="false"
                      [options]="optionsTravailARisque"
                      columns="1"
                      [derrors]="derrors"
                      label="Est-ce que vous effectuez un travail à risque ?"
                    >
                    </pr-input-radio>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer [form]="form" (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
